import { Polyline } from "react-leaflet";
import { StopCircle } from "../mapUtils/StopCircle";
import { PinMarker } from "../mapUtils/PinMarker";
import { BranchesMarker } from "../mapUtils/BranchesMarker";
import { ClockInMarker } from "../mapUtils/ClockInMarker";
import { ClockOutMarker } from "../mapUtils/ClockOutMarker";
import { PinHouseMarker } from "../mapUtils/PinHouseMarker";
import {
  EnhancedPinData,
  Branch,
  ClockInOutData,
  ClockIns,
  Stops,
  ColoredLines,
  Batida,
  Residencia,
} from "../../@types/mapTypes";

interface MapLayersProps {
  showOffBtnMap: { [key: string]: boolean };
  coloredTrajectoryLines: ColoredLines[];
  orangeTrajectoryLines: ColoredLines[];
  yellowTrajectoryLines: ColoredLines[];
  stopPoints: Stops[];
  markersWithDirection: EnhancedPinData[];
  branch: Branch[];
  mockClockIns: ClockIns[];
  clockInOutData: ClockInOutData[];
  batidas?: Batida[];
  employeeHome?: Residencia;
}

export function MapLayers({
  showOffBtnMap,
  coloredTrajectoryLines,
  orangeTrajectoryLines,
  yellowTrajectoryLines,
  stopPoints,
  markersWithDirection,
  branch,
  batidas,
  employeeHome,
}: MapLayersProps) {
  return (
    <>
      {showOffBtnMap.polylineAllPings &&
        yellowTrajectoryLines.map((line, index) => (
          <Polyline
            key={`yellow-${index}`}
            positions={line.positions}
            color="#DAA520"
            weight={10}
            opacity={0.7}
          />
        ))}
      {showOffBtnMap.polylineInsideClockIns &&
        coloredTrajectoryLines.map((line, index) => (
          <Polyline
            key={`green-${index}`}
            positions={line.positions}
            color="green"
            weight={10}
            opacity={0.7}
          />
        ))}
      {showOffBtnMap.polylineOutsideClockIns &&
        orangeTrajectoryLines.map((line, index) => (
          <Polyline
            key={`red-${index}`}
            positions={line.positions}
            color="red"
            weight={10}
            opacity={0.7}
          />
        ))}
      {showOffBtnMap.stopPoints &&
        stopPoints.map((stop, index) => (
          <StopCircle
            key={`stop-${index}`}
            position={[stop.start.latitude, stop.start.longitude]}
            duration={stop.duration}
            popupContent={
              <>
                Parada
                <br />
                Início: {new Date(stop.start.data_hora).toLocaleString()}
                <br />
                Fim: {new Date(stop.end.data_hora).toLocaleString()}
                <br />
                Duração: {stop.duration.toFixed(2)} minutos
              </>
            }
          />
        ))}
      {showOffBtnMap.marker &&
        markersWithDirection.map((item, index) => (
          <PinMarker
            key={index}
            position={[item.latitude, item.longitude]}
            popupContent={
              <>
                Point {index + 1}
                <br />
                Placa: {item.placa}
                <br />
                Data/Hora: {new Date(item.data_hora).toLocaleString()}
                <br />
                Velocidade: {item.velocidade} km/h
                <br />
                Latitude: {item.latitude}
                <br />
                Longitude: {item.longitude}
                <br />
                Direction: {item.rotation.toFixed(2)}°<br />
                Distance from previous: {item.distance.toFixed(2)} km
                <br />
                Total distance: {item.totalDistance.toFixed(2)} km
              </>
            }
          />
        ))}
      {showOffBtnMap.branches &&
        branch.map((item, index) => (
          <BranchesMarker
            key={index}
            position={[item.latitude, item.longitude]}
            popupContent={
              <>
                Filial: {item.filial}
                <br />
                Endereço: {`${item.endereco} ${item.estado}`}
                <br />
                Latitude: {item.latitude}
                <br />
                Longitude: {item.longitude}
                <br />
              </>
            }
          />
        ))}
      {batidas &&
        batidas.length > 0 &&
        batidas.map((batida, index) => {
          return (
            <>
              {batida.entrada_lat !== null && batida.entrada_lon !== null && (
                <ClockInMarker
                  key={`batida-entrada-${index}`}
                  position={[batida.entrada_lat, batida.entrada_lon]}
                  popupContent={
                    <>
                      Entrada de Ponto
                      <br />
                      Data/Hora: {new Date(batida.start).toLocaleString()}
                    </>
                  }
                />
              )}
              {batida.saida_lat !== null && batida.saida_lon !== null && (
                <ClockOutMarker
                  key={`batida-saida-${index}`}
                  position={[batida.saida_lat, batida.saida_lon]}
                  popupContent={
                    <>
                      Saída de Ponto
                      <br />
                      Data/Hora: {new Date(batida.end).toLocaleString()}
                    </>
                  }
                />
              )}
            </>
          );
        })}

      {/* Renderização da residência do funcionário */}
      {employeeHome &&
        employeeHome.latitude !== null &&
        employeeHome.longitude !== null && (
          <PinHouseMarker
            position={[employeeHome.latitude, employeeHome.longitude]}
            popupContent={
              <>
                Residência do Funcionário
                <br />
                Latitude: {employeeHome.latitude}
                <br />
                Longitude: {employeeHome.longitude}
              </>
            }
          />
        )}
    </>
  );
}
